var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg40(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 4.01562C4.85478 4.01562 5.48438 3.38603 5.48438 2.60938C5.48438 1.83272 4.85478 1.20312 4.07812 1.20312C3.30147 1.20312 2.67188 1.83272 2.67188 2.60938C2.67188 3.38603 3.30147 4.01562 4.07812 4.01562Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 4.01562C10.6204 4.01562 11.25 3.38603 11.25 2.60938C11.25 1.83272 10.6204 1.20312 9.84375 1.20312C9.0671 1.20312 8.4375 1.83272 8.4375 2.60938C8.4375 3.38603 9.0671 4.01562 9.84375 4.01562Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.60938H11.6729C12.5266 2.60938 13.2188 3.30148 13.2188 4.15527V6.55222C13.2188 8.56325 12.4371 10.4955 11.0388 11.9409L6.96094 16.1562L2.88305 11.9409C1.48481 10.4955 0.703125 8.56325 0.703125 6.55222V4.15527C0.703125 3.30148 1.39523 2.60938 2.24902 2.60938H2.67188",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 12.5469H10.3828",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96094 16.1562V17.0352C6.96094 20.7695 9.98827 23.7969 13.7227 23.7969C17.457 23.7969 20.4844 20.7695 20.4844 17.0352V8.9375",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 8.9375C22.0377 8.9375 23.2969 7.6783 23.2969 6.125C23.2969 4.5717 22.0377 3.3125 20.4844 3.3125C18.9311 3.3125 17.6719 4.5717 17.6719 6.125C17.6719 7.6783 18.9311 8.9375 20.4844 8.9375Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 6.125H21.1875",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg40);
export default __webpack_public_path__ + "static/media/40.426cdecdedc71a80a934f89f799bda31.svg";
export { ForwardRef as ReactComponent };